import './HotspotCounter.scss';

export default function HotspotCounter({ displayedCount, total, shouldAnimate = false }) {
    return (
        <div className={`hotspot-counter ${shouldAnimate ? 'hotspot-counter--animate-in' : ''}`}>
            <div className="hotspot-counter__button">
                <span className="hotspot-counter__circle"></span>
                <span className="hotspot-counter__fraction">
                    {displayedCount}/{total}
                </span>
            </div>
        </div>
    );
}